import SignInvestmentModal from './SignInvestmentModal';

export default SignInvestmentModal;
